/* tslint:disable */
/* eslint-disable */
/**
 * Hey Pharamcist API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { Product } from './product';
import { ProductVariant } from './product-variant';
import { UsedBy } from './used-by';
/**
 * 
 * @export
 * @interface PopulatedDiscount
 */
export interface PopulatedDiscount {
  _id?: string;
    /**
     * 
     * @type {Date}
     * @memberof PopulatedDiscount
     */
    createdAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof PopulatedDiscount
     */
    updatedAt?: Date;
    /**
     * 
     * @type {string}
     * @memberof PopulatedDiscount
     */
    id?: string;
    /**
     * Display name for the discount
     * @type {string}
     * @memberof PopulatedDiscount
     */
    name?: string;
    /**
     * Optional description for internal use
     * @type {string}
     * @memberof PopulatedDiscount
     */
    description?: string;
    /**
     * ITEM_DISCOUNT: Shows on products automatically. COUPON_CODE: Requires code at checkout
     * @type {string}
     * @memberof PopulatedDiscount
     */
    type?: PopulatedDiscountTypeEnum;
    /**
     * PERCENTAGE or FIXED_AMOUNT
     * @type {string}
     * @memberof PopulatedDiscount
     */
    valueType?: PopulatedDiscountValueTypeEnum;
    /**
     * The discount value (percentage 1-100 or fixed dollar amount)
     * @type {number}
     * @memberof PopulatedDiscount
     */
    value?: number;
    /**
     * Maximum discount amount for percentage discounts (optional, mainly for COUPON_CODE)
     * @type {number}
     * @memberof PopulatedDiscount
     */
    cappedAt?: number;
    /**
     * Coupon code (required for COUPON_CODE type)
     * @type {string}
     * @memberof PopulatedDiscount
     */
    code?: string;
    /**
     * When the discount becomes active
     * @type {Date}
     * @memberof PopulatedDiscount
     */
    startsAt?: Date;
    /**
     * When the discount expires
     * @type {Date}
     * @memberof PopulatedDiscount
     */
    expiresAt?: Date;
    /**
     * Current lifecycle state
     * @type {string}
     * @memberof PopulatedDiscount
     */
    state?: PopulatedDiscountStateEnum;
    /**
     * Quick toggle to enable/disable the discount
     * @type {boolean}
     * @memberof PopulatedDiscount
     */
    isActive?: boolean;
    /**
     * Maximum total times this discount can be used (optional)
     * @type {number}
     * @memberof PopulatedDiscount
     */
    maxUses?: number;
    /**
     * Maximum times a single user can use this discount (optional)
     * @type {number}
     * @memberof PopulatedDiscount
     */
    maxUsesPerUser?: number;
    /**
     * Current total usage count
     * @type {number}
     * @memberof PopulatedDiscount
     */
    numberOfUses?: number;
    /**
     * Usage history
     * @type {Array<UsedBy>}
     * @memberof PopulatedDiscount
     */
    usedBy?: Array<UsedBy>;
    /**
     * 
     * @type {string}
     * @memberof PopulatedDiscount
     */
    storeId?: string;
    /**
     * 
     * @type {Array<Product>}
     * @memberof PopulatedDiscount
     */
    productsEligible: Array<Product>;
    /**
     * 
     * @type {Array<ProductVariant>}
     * @memberof PopulatedDiscount
     */
    variantsEligible: Array<ProductVariant>;
}

/**
    * @export
    * @enum {string}
    */
export enum PopulatedDiscountTypeEnum {
    ITEMDISCOUNT = 'ITEM_DISCOUNT',
    COUPONCODE = 'COUPON_CODE'
}
/**
    * @export
    * @enum {string}
    */
export enum PopulatedDiscountValueTypeEnum {
    PERCENTAGE = 'PERCENTAGE',
    FIXEDAMOUNT = 'FIXED_AMOUNT'
}
/**
    * @export
    * @enum {string}
    */
export enum PopulatedDiscountStateEnum {
    ACTIVE = 'ACTIVE',
    INACTIVE = 'INACTIVE',
    EXPIRED = 'EXPIRED',
    SCHEDULED = 'SCHEDULED'
}

